import React, { useState } from "react";
import axios from "axios";
import "../../../center admin css/BUSampleForm.css"; // CSS
import "../../../center admin css/centerAdmin.css";
import api from "../../../api/axiosConfig";

interface FormComponentProps {
  emrId: string;
  name?: string;
  onComplete?: () => void;
}

export const BUSampleForm: React.FC<FormComponentProps> = ({
  emrId,
  name,
  onComplete,
}) => {
  const [bnuCollected, setBnuCollected] = useState<"" | "yes" | "no">("");
  const [loading, setLoading] = useState(false);



  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!bnuCollected) {
      alert("Please select if B&U sample was collected.");
      return;
    }

    setLoading(true);
    try {
      const payload = { emrId, sentToLab: bnuCollected === "yes" };
      console.log("Sending payload:", payload);

      const res = await api.dataCollectionApi.post(
        "/api/forms/blood-sample",
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      console.log("Response:", res.data);

      if (res.data?.success) {
       

        alert("Blood and Urine Sample submitted successfully!");

        // reset form
        setBnuCollected("");

        // ✅ only after successful validation
        onComplete && onComplete();
      } else {
        throw new Error(res.data?.message || "Save failed — invalid response.");
      }
    } catch (err: any) {
      console.error("Error:", err);
      alert(`Error: ${err?.response?.data?.message || err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="bu-form-container" onSubmit={handleSubmit}>
      {/* SECTION CARD */}
      <div className="vs-section-bar">B&U Sample</div>
      <div className="bu-section-card">
        <div className="bu-section-body">
          <div className="bu-label">Blood and Urine Sample Collected?</div>

          <div className="bu-radio-row">
            <label className="ack-radio">
              <input
                type="radio"
                name="bnu_collected"
                checked={bnuCollected === "yes"}
                onChange={() => setBnuCollected("yes")}
                disabled={loading}
              />
              <span className="radio-custom"></span>
              <span className="radio-label">Yes</span>
            </label>

            <label className="ack-radio">
              <input
                type="radio"
                name="bnu_collected"
                checked={bnuCollected === "no"}
                onChange={() => setBnuCollected("no")}
                disabled={loading}
              />
              <span className="radio-custom"></span>
              <span className="radio-label">No</span>
            </label>
          </div>
        </div>
      </div>

      {/* BUTTONS */}
      <div className="audio-actions">
        <button type="button" className="audio-btn audio-btn-secondary">
          Close
        </button>
        <button
          type="submit"
          className="audio-btn audio-btn-primary"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Assessment"}
        </button>
      </div>
    </form>
  );
};

export default BUSampleForm;
